import { render, staticRenderFns } from "./CommentListRead.vue?vue&type=template&id=62d832b9&"
import script from "./CommentListRead.vue?vue&type=script&lang=js&"
export * from "./CommentListRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports